/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Show_PublicInputs */

const cs_settings_profile_show_public = /** @type {(inputs: Settings_Profile_Show_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit veřejný profil`)
};

const en_settings_profile_show_public = /** @type {(inputs: Settings_Profile_Show_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show public profile`)
};

/**
* | output |
* | --- |
* | "Show public profile" |
*
* @param {Settings_Profile_Show_PublicInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_show_public = /** @type {((inputs?: Settings_Profile_Show_PublicInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Show_PublicInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_show_public(inputs)
	return cs_settings_profile_show_public(inputs)
});